var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LightSpeedOutRight = exports.LightSpeedOutLeft = exports.LightSpeedInRight = exports.LightSpeedInLeft = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animation = require("../../animation");
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_7942250460843_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withTiming,duration,animation,config,withSequence,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,withTiming(1,{duration:duration})),transform:[{translateX:delayFunction(delay,animation(0,{...config,duration:duration*0.7}))},{skewX:delayFunction(delay,withSequence(withTiming('10deg',{duration:duration*0.7}),withTiming('-5deg',{duration:duration*0.15}),withTiming('0deg',{duration:duration*0.15})))}]},initialValues:{opacity:0,transform:[{translateX:values.windowWidth},{skewX:'-45deg'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Lightspeed.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withTiming","duration","animation","config","withSequence","initialValues","callback","__closure","animations","opacity","transform","translateX","skewX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Lightspeed.ts"],"mappings":"AA2BW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,YAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAEX,aAAa,CAACC,KAAK,CAAEC,UAAU,CAAC,CAAC,CAAE,CAAEC,QAAQ,CAAEA,QAAS,CAAC,CAAC,CAAC,CACpES,SAAS,CAAE,CACT,CACEC,UAAU,CAAEb,aAAa,CACvBC,KAAK,CACLG,SAAS,CAAC,CAAC,CAAE,CAAE,GAAGC,MAAM,CAAEF,QAAQ,CAAEA,QAAQ,CAAG,GAAI,CAAC,CACtD,CACF,CAAC,CACD,CACEW,KAAK,CAAEd,aAAa,CAClBC,KAAK,CACLK,YAAY,CACVJ,UAAU,CAAC,OAAO,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,GAAI,CAAC,CAAC,CACjDD,UAAU,CAAC,OAAO,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CAClDD,UAAU,CAAC,MAAM,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAClD,CACF,CACF,CAAC,CAEL,CAAC,CACDI,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAEd,MAAM,CAACgB,WAAY,CAAC,CAAE,CAAED,KAAK,CAAE,QAAS,CAAC,CAAC,CACpE,GAAGP,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var LightSpeedInRight = exports.LightSpeedInRight = function(_ComplexAnimationBuil) {
    (0, _inherits2.default)(LightSpeedInRight, _ComplexAnimationBuil);
    var _super = _createSuper(LightSpeedInRight);
    function LightSpeedInRight() {
        var _this;
        (0, _classCallCheck2.default)(this, LightSpeedInRight);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var delayFunction = _this.getDelayFunction();
            var _this$getAnimationAnd = _this.getAnimationAndConfig(), _this$getAnimationAnd2 = (0, _slicedToArray2.default)(_this$getAnimationAnd, 2), animation = _this$getAnimationAnd2[0], config = _this$getAnimationAnd2[1];
            var delay = _this.getDelay();
            var duration = _this.getDuration();
            var callback = _this.callbackV;
            var initialValues = _this.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -10,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, (0, _animation.withTiming)(1, {
                                duration: duration
                            })),
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(0, Object.assign({}, config, {
                                        duration: duration * 0.7
                                    })))
                                },
                                {
                                    skewX: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)("10deg", {
                                        duration: duration * 0.7
                                    }), (0, _animation.withTiming)("-5deg", {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)("0deg", {
                                        duration: duration * 0.15
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    translateX: values.windowWidth
                                },
                                {
                                    skewX: "-45deg"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    animation: animation,
                    config: config,
                    withSequence: _animation.withSequence,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_7942250460843_init_data;
                anonymous.__workletHash = 7942250460843;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(LightSpeedInRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new LightSpeedInRight();
            }
        }
    ]);
    return LightSpeedInRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_9908199735275_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withTiming,duration,animation,config,withSequence,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,withTiming(1,{duration:duration})),transform:[{translateX:delayFunction(delay,animation(0,{...config,duration:duration*0.7}))},{skewX:delayFunction(delay,withSequence(withTiming('-10deg',{duration:duration*0.7}),withTiming('5deg',{duration:duration*0.15}),withTiming('0deg',{duration:duration*0.15})))}]},initialValues:{opacity:0,transform:[{translateX:-values.windowWidth},{skewX:'45deg'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Lightspeed.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withTiming","duration","animation","config","withSequence","initialValues","callback","__closure","animations","opacity","transform","translateX","skewX","windowWidth"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Lightspeed.ts"],"mappings":"AAgFW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,UAAA,CAAAC,QAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,YAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAEX,aAAa,CAACC,KAAK,CAAEC,UAAU,CAAC,CAAC,CAAE,CAAEC,QAAQ,CAAEA,QAAS,CAAC,CAAC,CAAC,CACpES,SAAS,CAAE,CACT,CACEC,UAAU,CAAEb,aAAa,CACvBC,KAAK,CACLG,SAAS,CAAC,CAAC,CAAE,CAAE,GAAGC,MAAM,CAAEF,QAAQ,CAAEA,QAAQ,CAAG,GAAI,CAAC,CACtD,CACF,CAAC,CACD,CACEW,KAAK,CAAEd,aAAa,CAClBC,KAAK,CACLK,YAAY,CACVJ,UAAU,CAAC,QAAQ,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,GAAI,CAAC,CAAC,CAClDD,UAAU,CAAC,MAAM,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAAC,CACjDD,UAAU,CAAC,MAAM,CAAE,CAAEC,QAAQ,CAAEA,QAAQ,CAAG,IAAK,CAAC,CAClD,CACF,CACF,CAAC,CAEL,CAAC,CACDI,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAACd,MAAM,CAACgB,WAAY,CAAC,CAAE,CAAED,KAAK,CAAE,OAAQ,CAAC,CAAC,CACpE,GAAGP,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var LightSpeedInLeft = exports.LightSpeedInLeft = function(_ComplexAnimationBuil2) {
    (0, _inherits2.default)(LightSpeedInLeft, _ComplexAnimationBuil2);
    var _super2 = _createSuper(LightSpeedInLeft);
    function LightSpeedInLeft() {
        var _this2;
        (0, _classCallCheck2.default)(this, LightSpeedInLeft);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.build = function() {
            var delayFunction = _this2.getDelayFunction();
            var _this2$getAnimationAn = _this2.getAnimationAndConfig(), _this2$getAnimationAn2 = (0, _slicedToArray2.default)(_this2$getAnimationAn, 2), animation = _this2$getAnimationAn2[0], config = _this2$getAnimationAn2[1];
            var delay = _this2.getDelay();
            var duration = _this2.getDuration();
            var callback = _this2.callbackV;
            var initialValues = _this2.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -10,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, (0, _animation.withTiming)(1, {
                                duration: duration
                            })),
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(0, Object.assign({}, config, {
                                        duration: duration * 0.7
                                    })))
                                },
                                {
                                    skewX: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)("-10deg", {
                                        duration: duration * 0.7
                                    }), (0, _animation.withTiming)("5deg", {
                                        duration: duration * 0.15
                                    }), (0, _animation.withTiming)("0deg", {
                                        duration: duration * 0.15
                                    })))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    translateX: -values.windowWidth
                                },
                                {
                                    skewX: "45deg"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withTiming: _animation.withTiming,
                    duration: duration,
                    animation: animation,
                    config: config,
                    withSequence: _animation.withSequence,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_9908199735275_init_data;
                anonymous.__workletHash = 9908199735275;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this2;
    }
    (0, _createClass2.default)(LightSpeedInLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new LightSpeedInLeft();
            }
        }
    ]);
    return LightSpeedInLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_8563697563821_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{translateX:delayFunction(delay,animation(values.windowWidth,config))},{skewX:delayFunction(delay,animation('-45deg',config))}]},initialValues:{opacity:1,transform:[{translateX:0},{skewX:'0deg'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Lightspeed.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateX","windowWidth","skewX"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Lightspeed.ts"],"mappings":"AAoIW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,SAAS,CAACH,MAAM,CAACY,WAAW,CAAER,MAAM,CACtC,CACF,CAAC,CACD,CACES,KAAK,CAAEZ,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,QAAQ,CAAEC,MAAM,CAAC,CACzD,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAE,CAAEE,KAAK,CAAE,MAAO,CAAC,CAAC,CACjD,GAAGR,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var LightSpeedOutRight = exports.LightSpeedOutRight = function(_ComplexAnimationBuil3) {
    (0, _inherits2.default)(LightSpeedOutRight, _ComplexAnimationBuil3);
    var _super3 = _createSuper(LightSpeedOutRight);
    function LightSpeedOutRight() {
        var _this3;
        (0, _classCallCheck2.default)(this, LightSpeedOutRight);
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        _this3 = _super3.call.apply(_super3, [
            this
        ].concat(args));
        _this3.build = function() {
            var delayFunction = _this3.getDelayFunction();
            var _this3$getAnimationAn = _this3.getAnimationAndConfig(), _this3$getAnimationAn2 = (0, _slicedToArray2.default)(_this3$getAnimationAn, 2), animation = _this3$getAnimationAn2[0], config = _this3$getAnimationAn2[1];
            var delay = _this3.getDelay();
            var callback = _this3.callbackV;
            var initialValues = _this3.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(values.windowWidth, config))
                                },
                                {
                                    skewX: delayFunction(delay, animation("-45deg", config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    translateX: 0
                                },
                                {
                                    skewX: "0deg"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_8563697563821_init_data;
                anonymous.__workletHash = 8563697563821;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this3;
    }
    (0, _createClass2.default)(LightSpeedOutRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new LightSpeedOutRight();
            }
        }
    ]);
    return LightSpeedOutRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_15858200966893_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{translateX:delayFunction(delay,animation(-values.windowWidth,config))},{skewX:delayFunction(delay,animation('45deg',config))}]},initialValues:{opacity:1,transform:[{translateX:0},{skewX:'0deg'}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Lightspeed.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","translateX","windowWidth","skewX"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Lightspeed.ts"],"mappings":"AAiLW,QAAC,CAAAA,SAAiCA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAE5C,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CACEC,UAAU,CAAEV,aAAa,CACvBC,KAAK,CACLC,SAAS,CAAC,CAACH,MAAM,CAACY,WAAW,CAAER,MAAM,CACvC,CACF,CAAC,CACD,CACES,KAAK,CAAEZ,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,OAAO,CAAEC,MAAM,CAAC,CACxD,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAE,CAAEE,KAAK,CAAE,MAAO,CAAC,CAAC,CACjD,GAAGR,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var LightSpeedOutLeft = exports.LightSpeedOutLeft = function(_ComplexAnimationBuil4) {
    (0, _inherits2.default)(LightSpeedOutLeft, _ComplexAnimationBuil4);
    var _super4 = _createSuper(LightSpeedOutLeft);
    function LightSpeedOutLeft() {
        var _this4;
        (0, _classCallCheck2.default)(this, LightSpeedOutLeft);
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        _this4 = _super4.call.apply(_super4, [
            this
        ].concat(args));
        _this4.build = function() {
            var delayFunction = _this4.getDelayFunction();
            var _this4$getAnimationAn = _this4.getAnimationAndConfig(), _this4$getAnimationAn2 = (0, _slicedToArray2.default)(_this4$getAnimationAn, 2), animation = _this4$getAnimationAn2[0], config = _this4$getAnimationAn2[1];
            var delay = _this4.getDelay();
            var callback = _this4.callbackV;
            var initialValues = _this4.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    translateX: delayFunction(delay, animation(-values.windowWidth, config))
                                },
                                {
                                    skewX: delayFunction(delay, animation("45deg", config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    translateX: 0
                                },
                                {
                                    skewX: "0deg"
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_15858200966893_init_data;
                anonymous.__workletHash = 15858200966893;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this4;
    }
    (0, _createClass2.default)(LightSpeedOutLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new LightSpeedOutLeft();
            }
        }
    ]);
    return LightSpeedOutLeft;
}(_animationBuilder.ComplexAnimationBuilder);
